import * as React from 'react';
import { Paper, PaperProps, createStyles } from '@mantine/core';

const useStyles = createStyles((theme) => ({
    card: {
        position: 'relative',
        overflow: 'hidden',
        border: '1px solid #dee2e6',
        maxWidth: 'calc(100vw - 18rem)',
        [theme.fn.smallerThan('sm')]: {
            borderRadius: 0,
            maxWidth: '100vw'
            // marginLeft: '10px',
            // marginRight: '10px'
        }
    },
    noMaxWidth: {
        maxWidth: '100vw'
    },
    noBorderRadius: {
        borderRadius: 0
    }
}));

interface CardProps extends PaperProps {
    children: React.ReactNode;
    noMaxWidth?: boolean;
    noBorderRadius?: boolean;
}

export const Card: React.FC<CardProps> = ({ children, noMaxWidth, noBorderRadius, ...props }) => {
    const { classes, cx } = useStyles();

    return (
        <Paper
            shadow="xs"
            className={cx(classes.card, {
                [classes.noMaxWidth]: noMaxWidth,
                [classes.noBorderRadius]: noBorderRadius
            })}
            {...props}
        >
            {children}
        </Paper>
    );
};
